import { configureStore } from '@reduxjs/toolkit'
import chooseItemReducer from './chooseItemsSlice'
import chooseWeekReducer from './chooseWeekSlice'
import rawDataReducer from './rawDataSlice'
import chooseItemGroupReducer from './chooseItemGroupSlice'
import dateDataReducer from './dateDataSlice'
import chartDataSlice from './chartDataSlice'
import loginReducer from './loginSlice'


export default configureStore({
  reducer: {
    chooseItem : chooseItemReducer,
    chooseWeek : chooseWeekReducer,
    rawData : rawDataReducer,
    chooseItemGroup : chooseItemGroupReducer,
    dateData : dateDataReducer,
    chartData : chartDataSlice,
    login : loginReducer
  }
})